export default {
    quotations: [],
    consolidity: [],
}
